export const formatLargeNumber = (
  number: number,
  {
    maximumFractionDigits = 1,
    notation = "compact",
    ...rest
  }: Intl.NumberFormatOptions = {}
) => {
  if (number === undefined || Number.isNaN(number)) {
    return "";
  }

  // Check for -0 case
  if (Object.is(number, -0)) {
    return "0";
  }

  return new Intl.NumberFormat("en-US", {
    notation,
    compactDisplay: "short",
    maximumFractionDigits,
    ...rest,
  }).format(number);
};

export const formatRoundNumber = (
  number: number,
  { notation = "standard" }: Intl.NumberFormatOptions = {}
) => {
  const maximumFractionDigits = number < 1 ? 2 : number < 10 ? 1 : 0;
  return formatLargeNumber(number, { maximumFractionDigits, notation });
};
